import { render, staticRenderFns } from "./CodeNumber.vue?vue&type=template&id=753701e2&scoped=true&"
import script from "./CodeNumber.vue?vue&type=script&lang=js&"
export * from "./CodeNumber.vue?vue&type=script&lang=js&"
import style0 from "./CodeNumber.vue?vue&type=style&index=0&id=753701e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753701e2",
  null
  
)

export default component.exports